import React, { useState, useEffect, useContext } from 'react';
import parse from 'html-react-parser';
import * as request from "../admin/lib/lib";
import { ParameterContext } from '../contexts/ParameterContext';
import { AuthContext } from '../contexts/AuthContext';
import Swal from "sweetalert2";

export function Home() {
    const [data, setData] = useState('');

    const { parameters } = useContext(ParameterContext)
    const { sessionToken } = useContext(AuthContext);

    useEffect(() => {
        const populateHome = async () => {
            try {
                const response = await request.get(process.env.REACT_APP_BACKEND_URL + 'GetInfo/Home');

                setData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
                Swal.fire({
                    title: "Възникна грешка",
                    text: `${error.message}`,
                    icon: "error",
                    button: "Добре",
                });
            }
        };

        if (!sessionStorage.getItem('sessionToken')) {
            sessionStorage.setItem('sessionToken', sessionToken);
        }

        populateHome();
        document.title = `Прием 1 клас - община ${parameters.municipality.obshtina_name}`;
    }, []); // The empty dependency array means this effect runs once, equivalent to componentDidMount.
    
    return (
        <div>
            <div className="cust_table menu">
                {Object.keys(data).length > 0 && (
                    data.news ? (
                        /*parse(data.news) // Parse only if data.news exists*/
                        <div
                            className="suneditor-preview"
                            dangerouslySetInnerHTML={{ __html: data.news }}
                        />
                    ) : (
                        <p>No news content available</p> // Fallback if data.news is missing
                    )
                ) }
            </div>
        </div>
    );
}

export default Home;